(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('bootstrap.dialog', modalDialog);

    modalDialog.$inject = ['$uibModal', '$templateCache'];

    /* @ngInject */
    function modalDialog($modal, $templateCache) {
        var service = {
            deleteDialog: deleteDialog,
            confirmationDialog: confirmationDialog,
            htmlBodyDialog: htmlBodyDialog,
            templateDialog: templateDialog
        };

        $templateCache.put('modalDialog.tpl.html',
                '<div>' +
                '    <div class="modal-header">' +
                '        <button type="button" class="close" data-dismiss="modal" ' +
                '            aria-hidden="true" data-ng-click="cancel()">&times;</button>' +
                '        <h5>{{title}}</h5>' +
                '    </div>' +
                '    <div class="modal-body">' +
                '        <p>{{message}}</p>' +
                '    </div>' +
                '    <div class="modal-footer">' +
                '        <button class="btn btn-primary" data-ng-click="ok()">{{okText}}</button>' +
                '        <button class="btn btn-info" data-ng-click="cancel()">{{cancelText}}</button>' +
                '    </div>' +
                '</div>');

        $templateCache.put('modalDialogHtml.tpl.html',
               '<div>' +
               '    <div class="modal-header">' +
               '        <button type="button" class="close" data-dismiss="modal" ' +
               '            aria-hidden="true" data-ng-click="cancel()">&times;</button>' +
               '        <h5>{{title}}</h5>' +
               '    </div>' +
               '    <div class="modal-body" ng-bind-html="message">' +
               '    </div>' +
               '    <div class="modal-footer">' +
               '        <button class="btn btn-primary" data-ng-click="ok()">{{okText}}</button>' +
               '    </div>' +
               '</div>');

        $templateCache.put('modalTemplateDialog.tpl.html',
            '<div>' +
            '    <div class="modal-header">' +
            '        <button type="button" class="close" data-dismiss="modal" ' +
            '            aria-hidden="true" data-ng-click="cancel()">&times;</button>' +
            '        <h5>{{title}}</h5>' +
            '    </div>' +
            '    <div class="modal-body" ng-include="includeTemplate">' +
            '    </div>' +
            '    <div class="modal-footer">' +
            '        <button class="btn btn-primary" data-ng-click="ok()">{{okText}}</button>' +
            '    </div>' +
            '</div>');

        return service;

        function deleteDialog(itemName, deleteMsg, okText, cancelText) {
            var title = 'Confirm Delete';
            itemName = itemName || 'item';
            var msg = deleteMsg || 'Delete ' + itemName + '?';

            return confirmationDialog(title, msg, okText, cancelText);
        }

        function htmlBodyDialog(title, msg) {
            return confirmationDialog(title, msg, "OK", "Cancel", "modalDialogHtml.tpl.html");
        }

        function templateDialog(title, template, scopeItem) {
            return confirmationDialog(title, "", "OK", "Cancel", "modalTemplateDialog.tpl.html", scopeItem, template);
        }

        function confirmationDialog(title, msg, okText, cancelText, templateUrl, scopeItem, includeTemplate) {
            var modalOptions = {
                templateUrl:  templateUrl || 'modalDialog.tpl.html',
                controller: ModalInstance,
                keyboard: true,
                resolve: {
                    options: function () {
                        return {
                            title: title,
                            message: msg,
                            okText: okText,
                            cancelText: cancelText,
                            item: scopeItem,
                            includeTemplate: includeTemplate
                        };
                    }
                }
            };

            return $modal.open(modalOptions).result;
        }
    }

    ModalInstance.$inject = ['$scope', '$uibModalInstance', 'options', 'dataservice', 'common', 'config', 'attachmentService'];

    /* @ngInject */
    function ModalInstance($scope, $modalInstance, options, dataservice, common, config, attachmentService) {
        $scope.item = options.item || {};
        $scope.isSaving = false;
        $scope.title = options.title || 'Title';
        $scope.message = options.message || '';
        $scope.okText = options.okText || 'OK';
        $scope.hasEmailBeenSet = false;
        $scope.cancelText = options.cancelText || 'Cancel';
        $scope.ok = function () {
            $modalInstance.close('ok');
        };
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.includeTemplate = options.includeTemplate || '';

        $scope.sendPasswordReset = function () {
            if (!$scope.hasEmailBeenSet) {
                if ($scope.item.sendTo) {
                    $scope.okText = "Close";
                    var dto = {
                        data: $scope.item.sendTo
                    }
                    dataservice.saveItem('api/Account/SendPasswordReset', dto, true, "", true).then(function (response) {
                        $scope.hasEmailBeenSet = true;
                    }, function (error) {
                        $modalInstance.close("ok");
                    })
                }
                else {
                    $modalInstance.close("ok");
                }
            }
            else {
                $modalInstance.close("ok");
            }
        }

        $scope.newNote = function () {
            if (!($scope.item.NewNote) ||  $scope.item.NewNote.trim() === "") {
                return;
            }
            $scope.isSaving = true;
            var noteDto = {};
            noteDto.BookingId = $scope.item.BookingId;
            noteDto.TaskId = $scope.item.TaskId;
            noteDto.Notes = $scope.item.NewNote;
            
            var parentType = noteDto.BookingId > 0 ? "BookingNote" : "TaskNote";

            dataservice.saveItem('api/DailySetup/NewNote', noteDto).then(function (saveResult) {
                $scope.isSaving = false;
                var savedNote = saveResult.data;
                attachmentService.upload(parentType, savedNote.ID, savedNote);
                
                $scope.item.NewNote = "";
                $scope.item.Notes.push(savedNote)
                $scope.item.Notes.sort(function (a, b) {
                    a = new Date(a.DateAddedUtc);
                    b = new Date(b.DateAddedUtc);
                    return a > b ? -1 : a < b ? 1 : 0
                });
            }).catch(function (error) {
                $scope.isSaving = false;
            });
            
        }

        $scope.completeItem = function (isComplete) {
            $scope.isSaving = true;
            var completionDto = {};
            completionDto.BookingId = $scope.item.BookingId;
            completionDto.TaskId = $scope.item.TaskId;
            completionDto.IsComplete = isComplete;

            dataservice.saveItem('api/DailySetup/NewCompletion', completionDto).then(function (saveResult) {
                common.notifier.notify(config.events.refreshCounts);
                $scope.isSaving = false;
                var savedCompletion = saveResult.data;
                $scope.item.Completions.push(savedCompletion);
                $scope.item.Completions.sort(function (a, b) {
                    a = new Date(a.DateAddedUtc);
                    b = new Date(b.DateAddedUtc);
                    return a > b ? -1 : a < b ? 1 : 0
                });
            }).catch(function (error) {
                $scope.isSaving = false;
            });


        }
    }
})();